import { Injectable, inject } from "@angular/core";
import { LorenBaseCrudService } from "../../../../shared/services/loren-base-crud-service/loren-base-crud.service";
import { LorenAutomationPlan } from "../../interfaces/loren-automation-plan.interface";
import { LorenAutomationPlansEndpointsService } from "../loren-automation-plans-endpoints-service/loren-automation-plans-endpoints.service";
import { KeyValuePair } from "../../../../shared/interfaces/key-value-pair.interface";
import { Observable } from "rxjs";
import { LOREN_PATH_PARAMS } from "../../../../shared/constants/loren-path-params.constants";
import { GenericItems } from "../../../../shared/interfaces/generic-items.interface";

@Injectable({
  providedIn: "root",
})
export class LorenAutomationPlanService extends LorenBaseCrudService<LorenAutomationPlan> {
  private endpoints: LorenAutomationPlansEndpointsService;

  constructor() {
    const endpoints = inject(LorenAutomationPlansEndpointsService);

    super(endpoints.userAutomationPlans());
    this.endpoints = endpoints;
  }

  getPlan(id: number, userId: string): Observable<LorenAutomationPlan> {
    const pathParams: KeyValuePair<string>[] = [
      {
        key: LOREN_PATH_PARAMS.userId,
        value: userId,
      },
    ];

    return super.get(id, {}, pathParams);
  }

  deletePlan(id: number, userId: string): Observable<LorenAutomationPlan> {
    const pathParams: KeyValuePair<string>[] = [
      {
        key: LOREN_PATH_PARAMS.userId,
        value: userId,
      },
    ];

    return super.del(id, pathParams);
  }

  getAllPlans(userId: string): Observable<GenericItems<LorenAutomationPlan>> {
    const pathParams: KeyValuePair<string>[] = [
      {
        key: LOREN_PATH_PARAMS.userId,
        value: userId,
      },
    ];

    return super.query({}, pathParams);
  }

  createPlan(userId: string, plan: LorenAutomationPlan) {
    const pathParams: KeyValuePair<string>[] = [
      {
        key: LOREN_PATH_PARAMS.userId,
        value: userId,
      },
    ];

    return super.create(plan, {}, pathParams);
  }

  updatePlan(planId: number, data: LorenAutomationPlan) {
    const endpoint = this.endpoints.updatePlan(planId);

    return this.http.patch<LorenAutomationPlan>(endpoint, data);
  }
}
